import {ReactNode, ChangeEvent, MouseEvent as ReactMouseEvent} from 'react';

import {TestIdProps} from 'shared/web';

export type InputPropsTypes = {
  isAllRowsSelected?: boolean;
};

export type CheckboxProps = {
  id?: string;
  name?: string;
  label?: string | ReactNode;
  isAllRowsSelected?: boolean;
  disabled?: boolean;
  checked?: boolean;
  readOnly?: boolean;
  className?: string;
  margin?: string;
  onClick?: (event: ReactMouseEvent<HTMLInputElement, MouseEvent>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
} & TestIdProps;
